import services from "@/http";
import * as types from "./mutation-types";
import { contatos_empty } from "@/components/Form/Contatos/get_contacts_empty";
import { endereco_empty } from "@/components/Form/Endereco/get_endereco_empty";

export const ActionGetAll = async ({ commit, dispatch }, payload) => {
  commit(types.SET_ISLOADING, true);
  let data = await dispatch("ActionFind", payload);
  dispatch("ActionSetConcedentesContatos", data.data);
  dispatch("ActionSetPagination", data.meta);
  commit(types.SET_ISLOADING, false);
};

export const ActionFind = async (store, payload) => {
  var concedentes_contatos = {
    data: [],
    meta: {},
  };

  await services.concedentes_contatos.get_all(payload).then((res) => {
    concedentes_contatos = res.data;
  });
  return concedentes_contatos;
};

export const ActionShow = async ({ commit, dispatch }, id) => {
  let response = null;
  commit(types.SET_ISLOADING, true);
  await services.concedentes_contatos.show({ id: id }).then((res) => {
    response = res.data.concedente_contato;
    dispatch("ActionSetConcedenteContato", response);
  });
  commit(types.SET_ISLOADING, false);
  return response;
};

export const ActionSave = async ({ commit, dispatch }, payload) => {
  commit(types.SET_ISLOADING, true);
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }
  commit(types.SET_ISLOADING, false);
};

export const ActionStore = async ({ commit }, payload) => {
  await services.concedentes_contatos.store(payload).then((res) => {
    commit(types.SET_CONCEDENTE_CONTATO, res.data.concedente_contato);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.concedentes_contatos
    .update({ id: payload.id }, payload)
    .then((res) => {
      commit(types.SET_CONCEDENTE_CONTATO, res.data.concedente_contato);
    });
};

export const ActionDelete = async ({ commit }, id) => {
  await services.concedentes_contatos.delete({ id: id }).then(() => {
    commit(types.SET_CONCEDENTE_CONTATO, null);
  });
};

export const ActionSetConcedentesContatos = ({ commit }, payload) => {
  commit(types.SET_CONCEDENTES_CONTATOS, payload);
};

export const ActionSetConcedenteContato = ({ commit }, payload) => {
  commit(types.SET_CONCEDENTE_CONTATO, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionNewConcedenteContato = ({ commit }) => {
  const concedente_contato = {
    nome: "",
    funcao: "",
    endereco: endereco_empty(),
    contatos: contatos_empty(),
  };
  commit(types.SET_CONCEDENTE_CONTATO, concedente_contato);
};
